import { notificationOrderId } from './pushClient.js'

export const markAllNotificationsRead = async token => {
    if (!token || localStorage.getItem('token') !== token) return false
    try {
        const response = await fetch('/api/notifications/read-all', {
            method: 'POST', keepalive: true, headers: { Authorization: `Bearer ${token}` },
        })
        return response.ok && localStorage.getItem('token') === token
    } catch { return false }
}

// Navigation is immediate. Telemetry failure must not trap a user in the bell.
export const openBellNotification = async (notification, { token, close, navigate, onRecorded }) => {
    if (!token || localStorage.getItem('token') !== token) return false
    close()
    const orderId = notificationOrderId(notification.url)
    if (orderId) navigate(`/orders/${orderId}`)
    try {
        const response = await fetch(`/api/notifications/${notification.id}/open-bell`, {
            method: 'POST', keepalive: true,
            headers: { Authorization: `Bearer ${token}` },
        })
        if (!response.ok || localStorage.getItem('token') !== token) return false
        onRecorded()
        return true
    } catch { return false }
}
